<template>
  <div class="playlist" v-if="videos.length > 0">
    <h2 v-if="showTitle">{{ playlist.title }}</h2>

    <div class="container">
      <video-thumbnail
        v-for="(video, i) in videos"
        :key="video.id"
        :video="video"
        :playlistId="id"
        :playlistGroupId="playlistGroupId"
        :index="i + 1"
        :hasAnimation="true"
        :isHighlighted="false"
        :isDemo="isDemo"
        @demoActivated="$emit('demoActivated')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'playlist',
  props: {
    isDemo: Boolean,
    id: {
      type: String,
      required: true
    },
    playlistGroupId: {
      type: String,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    playlist() {
      return this.$store.getters['contentTree/findPlaylist'](this.id)
    },
    videos() {
      return this.$store.getters['contentTree/findVideosFromPlaylist'](this.id)
    }
  },
  methods: {
    imageSrcSet(url, density) {
      return url.replace(/\.(jpg|png)/g, `_x${density}.$1`)
    }
  }
}
</script>

<style lang="scss" scoped>
.playlist {
  width: fit-content;
  text-align: left;
  margin-bottom: 16px;

  & > h2 {
    padding-left: 16px;
    font-size: 1.25rem;
    margin-top: 4px;
    color: #8d68fb;
  }

  .container {
    display: grid;
    grid-template-columns: repeat(2, 115px);
    grid-gap: 32px;
    margin: 16px;
    margin-top: 0;

    @media screen and (min-width: 1500px) {
      grid-template-columns: repeat(4, 260px);
    }

    @media screen and (min-width: 1100px) and (max-width: 1500px) {
      grid-template-columns: repeat(3, 260px);
    }

    @media screen and (min-width: 725px) and (max-width: 1100px) {
      grid-template-columns: repeat(2, 260px);
    }

    @media screen and (min-width: 375px) and (max-width: 725px) {
      grid-template-columns: repeat(2, 160px);
      grid-gap: 24px;
    }

    @media screen and (max-width: 375px) {
      grid-gap: 18px;
    }
  }
}
</style>
